var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState, useMemo } from 'react';
import { injectIntl } from '@s7ui-kit/s7ui-kit';
import { loadPartnersOffers } from '../../../../services/services/AdsService';
import useBreakpoint from '../../../../hooks/useBreakpoint';
import pushGA from '../../../../services/utils/pushGA';
import { Section } from '../../../main/Section';
import PartnerCard from './PartnerCard';
import HorizontalScroll from '../../../common/HorizontalScroll/HorizontalScroll';
import { analyticsMainPageBlockClick, analyticsMainPageBlockLoaded, analyticsMainPageBlockShown } from '../../../../services/analytics/analyticsMainpage';
import './partner-block.scss';
import mediaQueries from '../../../../assets/styles/mediaqueries.scss';
var CARD_LIMIT = 3;
var STANDING = 's7site_main';
var GA_CATEGORY = 'PORTAL PartnersMain';
var mobileMedia = mediaQueries.mobileMedia, tabletMedia = mediaQueries.tabletMedia, desktopMedia = mediaQueries.desktopMedia;
var queries = {
    MOBILE: mobileMedia,
    TABLET: tabletMedia,
    DESKTOP: desktopMedia
};
// const frontVersion = FRONTEND_VERSION;
var PartnerBlock = function (props) {
    var lang = props.lang;
    var words = props.words, getMessage = props.getMessage;
    var _a = useState([]), partnerItems = _a[0], setPartnerItems = _a[1];
    var deviceType = useBreakpoint({ queries: queries });
    var ecomParamsForGA = useMemo(function () {
        return partnerItems.map(function (partner, index) {
            return {
                item_id: partner.code,
                item_name: 'partner_offers',
                affiliation: 'marketplace',
                index: index + 1,
                location_id: 's7_main'
            };
        });
    }, [partnerItems]);
    useEffect(function () {
        if (partnerItems.length === 0) {
            return;
        }
        analyticsMainPageBlockLoaded({
            step: 'partner_offers',
            items: ecomParamsForGA
        });
    }, [partnerItems]);
    var inView = function () {
        setTimeout(function () {
            analyticsMainPageBlockShown({
                step: 'partner_offers',
                items: ecomParamsForGA,
                ux: deviceType.MOBILE ? 'carousel' : 'auto_open'
            });
        }, 2000);
    };
    var onClickArticle = function (index) {
        analyticsMainPageBlockClick({
            step: 'partner_offers',
            items: [ecomParamsForGA[index]]
        });
    };
    var onClickShowMore = function () {
        analyticsMainPageBlockClick({
            step: 'partner_offers',
            items: [{
                    item_id: 'all',
                    item_name: 'partner_offers',
                    affiliation: 'marketplace',
                    index: undefined,
                    location_id: 's7_main'
                }]
        });
    };
    useEffect(function () {
        var options = {
            lang: lang,
            limit: CARD_LIMIT,
            profileId: null,
            standing: STANDING
        };
        loadPartnersOffers({ body: JSON.stringify(options) })
            .then(function (response) {
            if (!response || !Array.isArray(response)) {
                setPartnerItems([]);
                return;
            }
            var sortedData = response.sort(function (a, b) {
                return b.score - a.score;
            });
            setPartnerItems(sortedData);
        }).catch(function () {
            setPartnerItems([]);
        });
    }, []);
    var renderItems = function () {
        var items = partnerItems.map(function (item, index) {
            var outLink = item.outLink, content2 = item.content2, milesRatioHuman = item.milesRatioHuman, picture1 = item.picture1, code = item.code;
            var props = {
                img: (picture1 === null || picture1 === void 0 ? void 0 : picture1.url) || '',
                title: content2,
                offer: milesRatioHuman,
                link: outLink
            };
            return React.createElement("div", { key: code, className: 'pb__card' },
                React.createElement(PartnerCard, __assign({}, props, { 
                    // @ts-ignore
                    onClick: function () { return onClickArticle(index); } })));
        });
        if (deviceType.DESKTOP) {
            return items;
        }
        if (deviceType.TABLET) {
            return items.slice(0, 2);
        }
        return React.createElement(HorizontalScroll, null, items);
    };
    if (partnerItems.length === 0) {
        return null;
    }
    return (React.createElement(Section, { title: getMessage(words, 'com.s7.main.page.partners.title'), className: 'pb', openInNewTab: true, onClick: function () {
            onClickShowMore();
            pushGA(GA_CATEGORY, 'Click_GoToMarketplace', getMessage(words, 'com.s7.main.page.partners.allLink'), {
                eventValue: 0,
                eventUX: 'TYPE:link',
                eventInteraction: 0
            });
        }, link: getMessage(words, 'com.s7.main.page.partners.allLink'), text: getMessage(words, 'com.s7.main.page.section.partner.show.all'), inView: inView },
        React.createElement("div", { className: 'pb__container' }, renderItems())));
};
export default injectIntl(React.memo(PartnerBlock));
